import { render } from "./FormTag.vue?vue&type=template&id=6cf4f65e"
import script from "./FormTag.vue?vue&type=script&lang=js"
export * from "./FormTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__